import { images } from "../constants";

const home = {
        image: images.home, // Home Image
        subtitle: "26 - 29 November, 2025 | Taipei, TW", // Event Dates & Location
        headingPart1: "",
        spanText: "WRG Competition NOW",
        headingPart2: "Game schedule updated all the time",
        buttonText: "THE LATEST SCHEDULE IS CONTINUING UPDATED.",
        buttonLink: "ScheduleTab",
};

export default home;